import { useMemo } from 'react';
import React from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';

interface User {
  email: string;
}

interface UserData {
  Items: User[];
}

interface TableExampleProps {
  userData: UserData; // Ensure this matches the type you're passing
}

const TableExample: React.FC<TableExampleProps> = ({ userData }) => {
  //should be memoized or stable
  const columns = useMemo<MRT_ColumnDef<User>[]>(
    () => [
      {
        accessorKey: 'email', // This assumes you want to display emails
        header: 'Email',
        size: 200,
      },
      {
        accessorKey: 'authorisations', // This assumes you want to display emails
        header: 'Authorisations',
        size: 200,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: userData.Items, // Use userData.Items here
  });

  return <MaterialReactTable table={table} />;
};

export default TableExample;
